import styled from 'styled-components'

export const StyledFacebookMessageConfirmOrder_Thead = styled.div`
  position: sticky;
  top: 0;
  z-index: 10;

  width: 100%;
  display: flex;
  align-items: center;

  background: #eff3fb;
  border-top: 1px solid #e2eaf8;

  .facebook-message-confirm-order-thead {
    &__th {
      height: 44px;
      padding: 12px 14px;

      font-size: 14px;
      font-weight: 600;
      line-height: 20px;

      &:nth-child(1) {
        padding-left: 24px;
        flex: 1;
      }
      &:nth-child(2) {
        width: 531px;
        text-align: center;
      }
      &:nth-child(3) {
        width: 200px;
        text-align: center;
      }
      &:nth-child(4) {
        width: 100px;
        text-align: center;
      }
    }

    &__icon {
      width: 16px;
      height: 16px;
      margin-left: 4px;

      display: inline-block;

      transform: translateY(2px);

      cursor: pointer;

      &[data-icon-only='true'] {
        position: relative;

        width: 16px;
        height: 16px;
        margin-left: 0;

        transform: unset;

        svg {
          position: absolute;
          top: 50%;
          left: 50%;

          transform: translate(-50%, -50%);
        }
      }

      svg {
        width: 100%;
        height: 100%;
      }
    }
  }
`
